import {
  CalendarMonth,
  Clear,
  Delete,
  Face,
  Forum,
  Send
} from '@mui/icons-material'
import { Grid, Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import EDButton from '../../../../atoms/EDButton/EDButton'
import EDCard from '../../../../atoms/EDCard/EDCard'
import EDInputWithLabel from '../../../../atoms/EDInput/EDInputWithLabel'
import Toast from '../../../../atoms/Toast/Toast'
import { fetchWithToken } from '../../../../utils/helpers/fetcher'
import './CommentSection.scss'

export default function CommentSection({ seedId }) {
  const { t } = useTranslation()
  const [comment, setComment] = useState('')
  const [comments, setComments] = useState([])
  const [toastMessage, setToastMessage] = useState({})
  const [showToast, setShowToast] = useState(false)

  const handleCancel = () => {
    setComment('')
  }

  const handleSend = async () => {
    let commentResponse = await fetchWithToken({
      path: `/seeds/${seedId}/comments`,
      method: 'POST',
      data: { message: comment }
    })
    setComment('')
    getComments()
    if (commentResponse.status != 'success') {
      setToastMessage({
        type: 'error',
        text: t('toast_activity_saved_error')
      })
      setShowToast(true)
    }
  }

  const handleDelete = async (commentId) => {
    let commentResponse = await fetchWithToken({
      path: `/seeds/${seedId}/comments`,
      method: 'DELETE',
      data: { commentGuids: [commentId] }
    })

    getComments()
    if (commentResponse.status != 'success') {
      setToastMessage({
        type: 'error',
        text: t('toast_activity_saved_error')
      })
      setShowToast(true)
    }
  }

  const getComments = async () => {
    let response = await fetchWithToken({
      path: `/seeds/${seedId}/comments?offset=0&pageSize=25`,
      method: 'GET'
    })
    if (response.status === 'success') {
      setComments(response.data.seedComents)
    }
  }

  const formatDate = (dateString) => {
    let date = new Date(dateString)
    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()
    let hour = date.getHours()
    let minute = date.getMinutes()

    if (day < 10) {
      day = '0' + day
    }
    if (month < 10) {
      month = '0' + month
    }
    if (hour < 10) {
      hour = '0' + hour
    }
    if (minute < 10) {
      minute = '0' + minute
    }

    let formattedDate = `${day}/${month}/${year} ${t(
      'time_text'
    )} ${hour}:${minute}`

    return formattedDate
  }

  useEffect(() => {
    getComments()
  }, [])

  return (
    <Grid item xs={12}>
      <Grid container spacing={3}>
        <Grid item md={12}>
          <EDCard elevation={0}>
            <Grid
              container
              spacing={2}
              justifyContent='flex-start'
              alignItems='center'
              className='comments-section'
            >
              <Grid item xs={12}>
                <div className='comments-section__title'>
                  <Forum /> {t('comments-title')}
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className='comments-section__form'>
                  <EDInputWithLabel
                    className='comments-section__form-input'
                    label={t('add_comment')}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  />

                  <Stack
                    direction='row'
                    spacing={1}
                    justifyContent='flex-start'
                    sx={{ paddingTop: '20px' }}
                  >
                    <EDButton
                      startIcon={<Send />}
                      disableElevation
                      variant='contained'
                      disabled={!comment.trim()}
                      onClick={handleSend}
                    >
                      {t('send_text')}
                    </EDButton>

                    {comment.trim() && (
                      <EDButton
                        startIcon={<Clear />}
                        disableElevation
                        variant='text'
                        onClick={handleCancel}
                      >
                        {t('clear_button')}
                      </EDButton>
                    )}
                  </Stack>
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className='comments-list'>
                  {comments.map((data) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        key={data.guid}
                        className='comments-list-item'
                      >
                        <div className='comments-list-item__header'>
                          <div className='comments-list-item__name'>
                            <Face /> {data.createdBy.name}{' '}
                            {data.createdBy.lastname}
                          </div>
                          <div className='comments-list-item__date'>
                            <CalendarMonth /> {formatDate(data.createdAt)}
                          </div>
                        </div>
                        <div className='comments-list-item__message'>
                          {data.message}
                        </div>
                        <div className='comments-list-item__actions'>
                          <div className='comments-list-item__delete-button'>
                            <EDButton
                              startIcon={<Delete />}
                              disableElevation
                              variant='contained'
                              color='error'
                              size='small'
                              onClick={() => handleDelete(data.guid)}
                            >
                              {t('delete')}
                            </EDButton>
                          </div>
                        </div>
                      </Grid>
                    )
                  })}
                </div>
              </Grid>
            </Grid>
          </EDCard>
        </Grid>
      </Grid>
      {showToast && (
        <Toast
          handleShowToast={setShowToast}
          type={toastMessage.type}
          text={toastMessage.text}
        />
      )}
    </Grid>
  )
}
